export class AutoCaptureTimer {
  private timer?: ReturnType<typeof setTimeout>
  private destroyed = false

  constructor(
    private readonly delayMs: number,
    private readonly onCapture: () => void
  ) {}

  /** Schedule capture if not already scheduled. No-op if already pending or destroyed. */
  public schedule(): void {
    if (this.timer !== undefined || this.destroyed) {
      return
    }
    this.timer = setTimeout(() => {
      this.timer = undefined
      if (!this.destroyed) {
        this.onCapture()
      }
    }, this.delayMs)
  }

  /** Cancel any pending capture. */
  public cancel(): void {
    if (this.timer !== undefined) {
      clearTimeout(this.timer)
      this.timer = undefined
    }
  }

  /** Cancel and prevent any future scheduling (call on unmount). */
  public destroy(): void {
    this.cancel()
    this.destroyed = true
  }
}
